import axiosInstance from "../axiosConfig";
import Cookies from "js-cookie";

// Получение данных текущего пользователя (аналог /me)
export const getCurrentUserData = async (): Promise<{
  organization_name: string;
  first_name: string;
  last_name: string;
  email: string;
  referral_token: string;
  verification_code: string;
}> => {
  const userId = Number(Cookies.get("user_id"));
  if (!userId) {
    throw new Error("User ID not found in cookies");
  }
  const url = `/users/${userId}/`;
  try {
    // Добавляем timestamp для предотвращения кеширования
    const response = await axiosInstance.get(url, {
      params: {
        _t: Date.now() // Параметр для предотвращения кеширования
      }
    });
    return response.data;
  } catch (error) {
    console.error("Ошибка при запросе данных пользователя:", error);
    throw error;
  }
};

// Получение данных пользователя
export const getUserData = async (
  userId: number
): Promise<{
  organization_name: string;
  first_name: string;
  last_name: string;
  email: string;
  referral_token: string;
  verification_code: string;
}> => {
  const url = `/users/${userId}/`;
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Ошибка при запросе данных пользователя:", error);
    throw error;
  }
};

// Обновление данных пользователя
export const updateUserData = async (
  userId: number,
  data: {
    organization_name?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    verification_code?: string;
  }
): Promise<void> => {
  const url = `/users/${userId}/`;
  try {
    await axiosInstance.patch(url, data);
  } catch (error) {
    console.error("Ошибка при обновлении данных пользователя:", error);
    throw error;
  }
};

// Получение настроек бота
export const getBotConfig = async (
  userId: number
): Promise<
  {
    id: number;
    user: number;
    bot_token: string;
    tech_support_tg_name: string;
  }[]
> => {
  const url = `/bot_config/?user_id=${userId}`;
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Ошибка при запросе настроек бота:", error);
    throw error;
  }
};

// Создание настроек бота
export const createBotConfig = async (data: { user: number; bot_token: string, tech_support_tg_name: string }): Promise<{ id: number }> => {
  const url = `/bot_config/`;
  try {
    const botId = `bot_${data.bot_token.substring(0, 10)}`; // Генерация bot_id
    const response = await axiosInstance.post(url, { ...data, bot_id: botId });
    return response.data;
  } catch (error) {
    console.error("Ошибка при создании настроек бота:", error);
    throw error;
  }
};


// Обновление настроек бота
export const updateBotConfig = async (
  botConfigId: number,
  userId: number,
  data: {
    bot_token?: string;
    tech_support_tg_name?: string;
  }
): Promise<void> => {
  const url = `/bot_config/${botConfigId}/?user_id=${userId}`;
  try {
    await axiosInstance.patch(url, data);
  } catch (error) {
    console.error("Ошибка при обновлении настроек бота:", error);
    throw error;
  }
};

// Удаление настроек бота(и самого бота)
export const deleteBotConfig = async (botConfigId: number): Promise<void> => {
  const url = `/bot_config/${botConfigId}/`;;
  try {
    await axiosInstance.delete(url);
  } catch (error) {
    console.error("Ошибка при удалении настроек бота:", error);
    throw error;
  }
};

// Перезапуск бота
export const restartBot = async (botConfigId: number): Promise<void> => {
  const url = `/bot_config/${botConfigId}/restart/`;;
  try {
    await axiosInstance.post(url);
  } catch (error) {
    console.error("Ошибка при перезапуске бота:", error);
    throw error;
  }
};